import React from 'react';
import FormsySimpleInput from './FormsySimpleInput';
import Calendar from 'react-calendar';
import moment from 'moment';

class DatePicker extends React.Component {
  state = {
    value: '',
    isOpen: false
  };

  render = () => {
    //todo: performance enhancements
    const { value } = this.state;
    const { name, placeholder, required } = this.props;
    const inputProps = {
      name,
      placeholder,
      required,
      value,
      onFocus: this.showCalendar
    };
  
    inputProps.value =
      inputProps.value instanceof moment
        ? inputProps.value.format('dddd, MMM D, YYYY') // ex. Tuesday, Jan 23, 2018
        : inputProps.value;

    return (
      <div className="simple-input--date-picker">
        <FormsySimpleInput type="text" autoComplete="off" {...inputProps} />
        {this.renderDatePicker()}
      </div>
    );
  };

  renderDatePicker = () => {
    const { isOpen, value } = this.state;
    // const {onChange, onClickDay, formatMonthYear, ...props} = this.props;
    // this is safer for now
    const props = {
      minDate: this.props.minDate ? this.props.minDate : null,
      maxDate: this.props.maxDate ? this.props.maxDate : null
    };
    if (value instanceof moment) props.value = value.toDate();
    if (isOpen)
      return (
        <div
          className="simple-input__date-picker"
          onMouseLeave={this.hideCalendar}
        >
          <Calendar
            {...props}
            calendarType="US"
            maxDetail="month"
            minDetail="year"
            onChange={this.handleClickDay}
            onClickDay={this.handleClickDay}
            formatMonthYear={(_, value) => moment(value).format('MMM YYYY')}
          />
        </div>
      );
  };

  handleClickDay = val => {
    const value = moment(val);
    this.setState({ value, isOpen: false });

    if ('onChange' in this.props) this.props.onChange(value, this.props.name); // passes a moment obj
  };

  // intentionally does nothing- can't type
  handleChange = e => {};

  showCalendar = () => {
    this.setState({ isOpen: true });
  };

  hideCalendar = () => {
    this.setState({ isOpen: false });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      value: nextProps.value === null ? '' : moment(nextProps.value) || ''
    };
  }

  static defaultProps = {
    value: '',
    name: 'date'
  };
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/form/DatePicker.js